module.exports = __webpack_public_path__ + "media/assets/images/claim-places/check-empty-7d8e25d6417e00d8b9f482e435d30620.svg";